var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOffline(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#4FAADB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_935_336)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.35603 10.2012C13.648 7.48116 20.2852 8.22641 24.8409 12.4401C25.049 12.6326 25.0531 12.9585 24.8522 13.1582L23.7822 14.2198C23.5903 14.4101 23.2815 14.4145 23.0822 14.2317C19.6253 11.0647 14.7425 10.2986 10.5956 11.9322L8.35603 10.2012Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.53089 11.3186C6.0563 11.6603 5.59799 12.0341 5.15904 12.4401C4.95091 12.6326 4.94685 12.9585 5.1481 13.1582L6.2181 14.2198C6.40997 14.4104 6.71872 14.4145 6.9181 14.2317C7.45359 13.7411 8.02333 13.3081 8.61927 12.9327L6.53089 11.3186Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7568 14.5848C10.0144 14.9506 9.31054 15.4184 8.66654 15.9879C8.45091 16.1785 8.44404 16.5095 8.64872 16.7113L9.72497 17.7735C9.91247 17.9585 10.2143 17.971 10.414 17.7985C11.2031 17.1164 12.1105 16.6399 13.0648 16.3686L10.7568 14.5848Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0982 16.1851C17.3564 16.3823 18.5699 16.9204 19.5856 17.7985C19.7853 17.971 20.0872 17.9588 20.2747 17.7735L21.3509 16.7113C21.5559 16.5095 21.5487 16.1782 21.3334 15.9879C19.0051 13.9289 15.8975 13.2023 13.0191 13.8053L16.0982 16.1851Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 20.6001C13 19.4954 13.8953 18.6001 15 18.6001C16.1047 18.6001 17 19.4954 17 20.6001C17 21.7048 16.1047 22.6001 15 22.6001C13.8953 22.6001 13 21.7048 13 20.6001Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5792 22.4951L5.193 8.2846C4.97519 8.11522 4.93581 7.80115 5.10519 7.58303L5.71895 6.79333C5.88833 6.5752 6.2027 6.53583 6.42083 6.70552L24.807 20.916C25.0248 21.0854 25.0642 21.3994 24.8948 21.6176L24.281 22.4073C24.1117 22.6254 23.7973 22.6645 23.5792 22.4951Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_935_336"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(5 5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffline);
export default __webpack_public_path__ + "static/media/offline.e25730436b4606fdbe0c4f4e6de9d9eb.svg";
export { ForwardRef as ReactComponent };